import React from 'react';
import { times } from 'lodash-es';
import { PropTypes, describe } from '@elliemae/ds-props-helpers';
import { styled, truncate } from '@elliemae/ds-system';
import { Grid } from '@elliemae/ds-grid';

const Title = styled.h3`
  font-size: 18px;
  margin: 0;
  color: ${(props) => props.theme.colors.neutral['700']};
  line-height: inherit;
  ${truncate()}
  font-weight: ${(props) => props.theme.fontWeights.semibold};
`;

const CategoryBox = styled(Grid)`
  background: ${(props) => props.theme.colors.neutral['0']};
  border-top: ${(props) => (props.hasBorderTop ? `1px solid ${props.theme.colors.neutral['100']}` : 'none')};
`;

const DSCategoryBox = ({ borderTop = true, actionsRight = [], title, headerLevel = 3, children }) => {
  const rows = ['auto'];
  const hasActions = actionsRight.length > 0;
  if (hasActions) rows.push('auto');

  const cols = React.useMemo(() => times(actionsRight.length, () => 'auto'), [actionsRight.length]);

  return (
    <Grid rows={['40px', 'auto']}>
      <CategoryBox
        cols={rows}
        hasBorderTop={borderTop}
        alignItems="center"
        pl="xs"
        pr={actionsRight.length > 0 ? 'xxs' : 'xs'}
      >
        <Title as={`h${headerLevel}`}>{title}</Title>
        {hasActions && (
          <Grid cols={cols} justifySelf="end">
            {actionsRight}
          </Grid>
        )}
      </CategoryBox>
      {children}
    </Grid>
  );
};

const props = {
  /**
   * Category Box title
   */
  title: PropTypes.string.isRequired.description('Category Box title'),
  /**
   * Toggle border top of category box
   */
  borderTop: PropTypes.bool.description('Toggle border top of category box'),
  /**
   * Array of button icons
   */
  actionsRight: PropTypes.arrayOf(PropTypes.element).description('Array of button icons'),
  /**
   * semantic level of header tag for the title
   */
  headerLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]).description('semantic level of header tag for the title'),
  /**
   * In-box children
   */
  children: PropTypes.element.description('In-box children'),
};

DSCategoryBox.displayName = 'DSCategoryBox';
const DSCategoryBoxWithSchema = describe(DSCategoryBox);
DSCategoryBoxWithSchema.propTypes = props;

export { DSCategoryBox, DSCategoryBoxWithSchema };
